import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IProgram } from 'typings/doenkids/doenkids';
import { IProgramListState, ProgramListStore } from './program-list.store';

@Injectable({ providedIn: 'root' })
export class ProgramListQuery extends QueryEntity<IProgramListState, IProgram> {
  constructor(protected store: ProgramListStore) {
    super(store);
  }
}
